import React from 'react';
import PropTypes from 'prop-types';
import ProductFactory from 'factories/Products';

const ProductQuantity = (props) => {

    let quantityUnit = 0;
    let item = {};
    let unitSale = false;


    item = props.item;
    unitSale = props.unitSale;
    let qtyNumber = parseFloat(props.quantity * item.unitMultiplier).toFixed(2);
    if((qtyNumber - Math.floor(qtyNumber)) == 0){
        qtyNumber = Math.floor(qtyNumber);
    }
    quantityUnit = item ? ProductFactory.formatWeight(item.measurementUnit, qtyNumber) : '';

    if(!unitSale){
        return (
            <>{quantityUnit}</>
        )
    }
    else{
        return (
            <>{props.quantity + 'un.  ('+ quantityUnit})</>
        )
    }

}

ProductQuantity.propTypes = {
    quantity: PropTypes.number,
    item: PropTypes.object,
    unitSale : PropTypes.bool
};

export default ProductQuantity;
